<template>
  <div v-if="!dataIsNull">
    <b-jumbotron
      :header="objProcess.task_data.bpm_task_data.task_label"
      :lead="'Last Update: ' + objProcess.task_data.last_update_dt"
      id="last-version-jumbo"
    >
      <b-button variant="primary" @click="previewToggle = !previewToggle">Preview Form</b-button>
    </b-jumbotron>
    <div id="taskTreeBox" :class="previewToggle ? 'tree-show' : ''">
      <template>
        <BpmTaskColumnForm :objItems="objItems"></BpmTaskColumnForm>
      </template>
    </div>

    <!-- Table Grid -->
    <b-table
      selectable
      select-mode="single"
      selectedVariant="secondary"
      hover
      show-empty
      :items="objItems"
      :fields="!viewFind?objFilds:objFildsFind"
      @row-clicked="gridSelected"
    >
      <!-- TEMPLATE EMPTY -->
      <template slot="empty">
        <p>Nenhum registro encontrado</p>
      </template>

      <!-- TEMPLATE NUM-RECORD -->
      <template
        slot="num-record"
        slot-scope="data"
      >{{ data.index + 1 * ((numPage * rowLimit) - rowLimit) + 1 }}</template>

      <!-- TEMPLATE ACTION -->
      <template v-slot:cell(actions)="row" v-if="!viewFind">
        <b-button
          size="sm"
          pill
          variant="outline-secondary"
          :disabled="checkRelease()"
          @click="rowSelected(row.item)"
        >
          <i class="fas fa-pen"></i>
        </b-button>
      </template>
    </b-table>

    <!-- PAGINATION -->
    <b-pagination
      size="sm"
      pills
      v-model="numPage"
      :total-rows="rowCount"
      :per-page="rowLimit"
      align="center"
      class="btn-default"
    />
  </div>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - PAGE */
import BpmTaskColumnForm from "./BpmTaskColumnForm";

export default {
  name: "BpmTaskColumnGrid",
  components: { BpmTaskColumnForm },
  computed: {
    viewFind() {
      return this.$store.state.layout.viewFind;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objFilter() {
      return this.$store.state.objFilter;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    objProcess() {
      return this.$store.state.objProcess;
    },
    applyFilter() {
      return this.$store.state.applyFilter;
    },
    resetFilter() {
      return this.$store.state.resetFilter;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      previewToggle: false,

      /* Controls */
      urlServices: "chameleon-ds/api/internal/bpm-task-column",
      primary_key: "bpm_task_column_id",
      numPage: 1,
      rowLimit: 0,
      rowCount: 0,
      dataIsNull: true,

      /* Objects Page */
      nameObjData: "bpm_task_column_data",
      objItems: [],
      objFilds: [
        { key: "num-record", label: "", class: "cell-num-record" },
        { key: "actions", label: "", class: "cell-action" },
        {
          key: "bpm_task_column_id",
          label: "Task Column Id",
          sortable: true
        },
        {
          key: "bpm_task_column_data.column_order",
          label: "Order",
          sortable: true
        },
        {
          key: "bpm_task_column_data.task_column_label",
          label: "Column Label",
          sortable: true
        },
        {
          key: "bpm_task_column_data.task_column_name",
          label: "Column Name",
          sortable: true
        },
        {
          key: "bpm_task_column_data.column_type",
          label: "Type",
          sortable: true
        },
        /*{
          key: "bpm_task_column_data.min_size",
          label: "Min Size",
          sortable: true
        },*/
        {
          key: "bpm_task_column_data.max_size",
          label: "Max Size",
          sortable: true
        },
        /*{
          key: "bpm_task_column_data.column_mask",
          label: "Column Mask",
          sortable: true
        },*/
        /*{
          key: "bpm_task_column_data.default_value",
          label: "Default Value",
          sortable: true
        },*/
        {
          key: "bpm_task_column_data.column_required",
          label: "Required",
          sortable: true
        },
        {
          key: "bpm_task_column_data.read_only",
          label: "Read Only",
          sortable: true
        }
      ],
      objFildsFind: [
        { key: "num-record", label: "", class: "cell-num-record" },
        { key: "actions", label: "", class: "cell-action" },
        {
          key: "bpm_task_data.task_column_name",
          label: "Column Name",
          sortable: true
        },
        { key: "access_key", label: "Access Key", sortable: true }
      ]
    };
  },

  /* METHODS */
  methods: {
    init() {
      this.list();
    },
    list() {
      this.$store.commit("setShowLoading", true);
      this.objItems = [];
      let paramFilter = {};

      let id = this.objProcess.task_data
        ? this.objProcess.task_data.bpm_task_id
        : this.objProcess.bpm_task_id;

      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objFilter).length > 0) {
          paramFilter = { ...this.objFilter };
        }

        if (Object.entries(paramFilter).length === 0) {
          const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find-all-by-bpm-task-id`;
          paramFilter = { bpm_task_id: id };
          axios.post(url, paramFilter).then(res => {
            if (res.data[0][`${this.primary_key}`] != null)
              this.objItems = res.data;
            this.$store.commit("setShowLoading", false);
          });
        } else {
          const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find-all-by-filter`;
          axios.post(url, paramFilter).then(res => {
            if (res.data[0][`${this.primary_key}`] != null)
              this.objItems = res.data;
            this.$store.commit("setObjFilter", {});
            this.$store.commit("setShowLoading", false);
          });
        }
      }
    },
    rowSelected(item) {
      this.$emit("selectedBpmTaskColumn", item);
    },
    gridSelected(items) {
      if (this.viewFind === false && items) {
        this.$store.commit("setObjSelected", items);
      }
    },
    checkRelease() {
      if (this.objProcess) {
        if (
          this.objProcess.process_data.bpm_process_data.end_dt ||
          this.objProcess.version_data.bpm_process_version_data.end_dt
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    getDataIsNull() {
      if (this.objProcess) {
        if (this.objProcess.task_data) {
          this.dataIsNull = false;
        } else {
          this.dataIsNull = true;
        }
      } else {
        this.dataIsNull = true;
      }
    }
  },

  /* WATCH */
  watch: {
    applyFilter() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.applyFilter === true) {
          this.list();
        }
      }
    },
    resetFilter() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.resetFilter === true) {
          this.list();
        }
      }
    },
    urlServicesStore() {
      if (this.urlServicesStore === this.urlServices) {
        this.$store.commit("setObjFilter", {});
        this.list();
      }
    },
    objProcess() {
      this.getDataIsNull();
    }
  },

  /* LIFE CICLE */
  mounted() {
    if (this.objProcess)
      if (this.objProcess.task_data) {
        this.init();
        this.getDataIsNull();
      }
  }
};
</script>